import { z } from 'zod';

export enum editStateEnum {
  new = 'new', // not yet submitted forlookup
  pending = 'pending', // requested to backend and waiting for response
  local = 'local', // the word has been checked by client-side and suggestions are available if there are any
  checked = 'checked', // the word has been checked by backend and suggestions are available if there are any
  replaced = 'replaced', // the word has been replaced by the user
  discarded = 'discarded', // the word has been discarded in the llm suggestion process - this should be highlighted to the user
  invalid = 'invalid', // the token is invalid in some way (eg. the input is not found in the input string / the token contains multiple tokens / etc.)
}

/**
 * Return the higher-priority of the two edit states.
 * Priority: new > local > checked (> replaced / discarded / pending / invalid).
 * Used to enforce a minimum state floor (e.g. "at least local").
 */
export function maxEditState(a: editStateEnum, b: editStateEnum): editStateEnum {
  const rank: Record<editStateEnum, number> = {
    [editStateEnum.new]: 5,
    [editStateEnum.local]: 4,
    [editStateEnum.checked]: 3,
    [editStateEnum.replaced]: 2,
    [editStateEnum.discarded]: 1,
    [editStateEnum.pending]: 0,
    [editStateEnum.invalid]: 0,
  };
  return rank[a] >= rank[b] ? a : b;
}

export const zodEditStateEnum = z
  .enum(Object.values(editStateEnum) as [string, ...string[]])
  .transform((val) => val.toLowerCase());

export type editStateEnumType = z.infer<typeof zodEditStateEnum>;

export enum spellingStateEnum {
  unchecked = 'unchecked', // the word has not been checked
  correct = 'correct', // the word is known and is probably correct in context
  contextual = 'contextual', // the word is known but is probably not correct in context
  misspelled = 'misspelled', // the word is misspelled and has suggestions
  user = 'user', // the word is something the user added to their personal dictionary and should be treated as correct << NOT IN USE YET >>
  unknown = 'unknown', // the word is unknown and has no suggestions
  recovered = 'recovered', // not in SCOWL, no validated suggestions — GPT has an unvalidated suggestion (e.g. proper noun, brand name)
  ignore = 'ignore' // the word is not something to look up, email/url/@mention/ip-address etc..
}

export const zodSpellingStateEnum = z
  .enum(Object.values(spellingStateEnum) as [string, ...string[]])
  .transform((val) => val.toLowerCase());

export type spellingStateEnumType = z.infer<typeof zodSpellingStateEnum>;
